export const loadLogEventInDogfoodPerfHUDStoreMiddleware = (): Promise<typeof import('./middleware')> =>
  import(/* webpackChunkName: "4-feat-dogfood-perf-hud-middleware" */ './middleware');
